import { Injectable,EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BreadCrumbsService {

  public breadcrumbs: any[] = new Array<any>();
public onNavigateBack: EventEmitter<string> = new EventEmitter<string>();
  constructor() { }

public navigateBack(){
  this.onNavigateBack.emit('');
}
}
